<template>
  <div>客户经理业绩排行</div>
</template>

<script>
export default {
  name: 'AccountManagerPerformance'
}
</script>

<style scoped>
</style>
